<div class="page-component"><mat-card [innerHtml]="content"></mat-card></div>
